import { createCn } from "cn/config";

/**
 * Tailwind class merging that knows the design type roles (`globals.css`).
 * Without this, `cn("text-caution-fg", "text-label")` reads `text-label` as
 * a colour and drops the tone. Import `cn` from here, never from "cn".
 */
export const TYPE_ROLES = [
  "display",
  "title",
  "section",
  "sub",
  "body",
  "compact",
  "label",
  "caption",
  "stat",
] as const;

export const cn = createCn({
  extend: { classGroups: { "font-size": [{ text: [...TYPE_ROLES] }] } },
});
